import { SidebarItemsType } from 'app/campaign/widgets.model';

export enum FontMetricsTypes {
  FontSize = 'font-size',
  LineHeight = 'line-height',
  FontWeight = 'font-weight',
  LetterSpacing = 'letter-spacing',
  NailImageWidth = 'nailImageWidth',
}

export enum FontMetricsProps {
  FontSize = 'fontSize',
  LineHeight = 'lineHeight',
  FontWeight = 'fontWeight',
  LetterSpacing = 'letterSpacing',
  ResultFontSize = 'resultFontSize',
  Width = 'width',
}

export enum FontMetricsEntity {
  Value = 'value',
  ValueMobile = 'valueMobile',
  UpdatedPart = 'updatedPart',
  UpdatedPartMobile = 'updatedPartMobile',
}

export const FontMetricsConfig = {
  [SidebarItemsType.Text]: {
    sidebarPart: [SidebarItemsType.Text],
    fontMetrics: [
      {
        name: FontMetricsTypes.FontSize,
        prop: FontMetricsProps.FontSize,
        updatedPart: 'textProperties.fontSize',
        updatedPartMobile: 'mobile.fontSize',
        value: '',
        valueMobile: '',
        toggleDevices: true,
        canHaveBrandVariable: true,
      },
      {
        name: FontMetricsTypes.FontWeight,
        prop: FontMetricsProps.FontWeight,
        updatedPart: 'textProperties.fontWeight',
        value: '',
        defaultValue: 400,
        canHaveBrandVariable: true,
      },
      {
        name: FontMetricsTypes.LineHeight,
        prop: FontMetricsProps.LineHeight,
        updatedPart: 'textProperties.lineHeight',
        updatedPartMobile: 'mobile.lineHeight',
        value: '',
        valueMobile: '',
        toggleDevices: true,
        defaultValue: '14px',
        canHaveBrandVariable: true,
      },
      {
        name: FontMetricsTypes.LetterSpacing,
        prop: FontMetricsProps.LetterSpacing,
        updatedPart: 'textProperties.letterSpacing',
        updatedPartMobile: 'mobile.letterSpacing',
        value: '',
        defaultValue: '',
        canHaveBrandVariable: true,
      },
    ],
    toggleDevices: true,
  },
  textV2FontSettings: {
    sidebarPart: [SidebarItemsType.Text],
    fontMetrics: [
      {
        name: FontMetricsTypes.FontWeight,
        prop: FontMetricsProps.FontWeight,
        updatedPart: 'textProperties.fontWeight',
        value: '',
        defaultValue: 400,
        canHaveBrandVariable: true,
      },
      {
        name: FontMetricsTypes.LineHeight,
        prop: FontMetricsProps.LineHeight,
        updatedPart: 'textProperties.lineHeight',
        updatedPartMobile: 'mobile.lineHeight',
        value: '',
        valueMobile: '',
        toggleDevices: true,
        defaultValue: '14px',
        canHaveBrandVariable: true,
      },
      {
        name: FontMetricsTypes.LetterSpacing,
        prop: FontMetricsProps.LetterSpacing,
        updatedPart: 'textProperties.letterSpacing',
        updatedPartMobile: 'mobile.letterSpacing',
        value: '',
        defaultValue: '',
        canHaveBrandVariable: true,
      },
    ],
    toggleDevices: true,
  },
  [SidebarItemsType.MemoryPrize]: {
    sidebarPart: [SidebarItemsType.MemoryPrize],
    fontMetrics: [
      {
        name: FontMetricsTypes.FontSize,
        updatedPart: 'memoryProperties.resultFontSize',
        updatedPartMobile: 'memoryProperties.mobile.resultFontSize',
        value: '',
        valueMobile: '',
        toggleDevices: true,
      },
    ],
    toggleDevices: true,
  },
  [SidebarItemsType.SpinTheWheelSpinButton]: {
    sidebarPart: [SidebarItemsType.SpinTheWheelSpinButton],
    fontMetrics: [
      {
        name: FontMetricsTypes.FontSize,
        updatedPart: 'spinTheWheelProperties.spinButtonFontSize',
        updatedPartMobile: 'spinTheWheelProperties.mobile.spinButtonFontSize',
        value: '',
        valueMobile: '',
        toggleDevices: true,
      },
    ],
    toggleDevices: true,
  },
  [SidebarItemsType.SpinTheWheelItemsAppearance]: {
    sidebarPart: [SidebarItemsType.SpinTheWheelItemsAppearance],
    fontMetrics: [
      {
        name: FontMetricsTypes.FontSize,
        updatedPart: 'spinTheWheelProperties.sliceFontSize',
        updatedPartMobile: 'spinTheWheelProperties.mobile.sliceFontSize',
        value: '',
        valueMobile: '',
        toggleDevices: true,
      },
    ],
    toggleDevices: true,
  },
  [SidebarItemsType.SpinTheWheelPrize]: {
    sidebarPart: [SidebarItemsType.SpinTheWheelPrize],
    fontMetrics: [
      {
        name: FontMetricsTypes.FontSize,
        updatedPart: 'spinTheWheelProperties.prizeFontSize',
        updatedPartMobile: 'spinTheWheelProperties.mobile.prizeFontSize',
        value: '',
        valueMobile: '',
        toggleDevices: true,
      },
    ],
    toggleDevices: true,
  },
  [SidebarItemsType.SpinTheWheelSettings]: {
    sidebarPart: [SidebarItemsType.SpinTheWheelSettings],
    fontMetrics: [
      {
        name: FontMetricsTypes.NailImageWidth,
        updatedPart: 'spinTheWheelProperties.wheelNailImageWidth',
        updatedPartMobile: 'spinTheWheelProperties.mobile.wheelNailImageWidth',
        value: '',
        valueMobile: '',
        toggleDevices: true,
      },
    ],
    toggleDevices: true,
  },
};
